import classNames from 'classnames';

export enum BadgeSize {
  ExtraSmall,
  Small,
}

export interface BadgeProps {
  text: string;
  BackgroundColor?: BadgeColor;
  size?: BadgeSize;
  testId?: string;
}
export enum BadgeColor {
  Primary = 'bg-igus-primary',
  Info = 'bg-igus-info',
}

export const Badge = ({ text = '', BackgroundColor, size = BadgeSize.Small, testId = 'badge' }: BadgeProps) => (
  <div className={classNames('absolute', 'z-20')} data-testid={testId}>
    <span
      className={classNames(
        BackgroundColor ?? 'bg-igus-info',
        'text-white',
        'absolute',
        'top-0',
        'left-0',
        'block',
        size === BadgeSize.ExtraSmall ? 'px-2' : 'px-4',
        size === BadgeSize.ExtraSmall ? 'py-1' : 'py-2',
        size === BadgeSize.ExtraSmall ? 'text-xxs' : 'text-xs'
      )}
    >
      {text}
    </span>
  </div>
);
